import React, { useEffect, useRef } from "react";

const DDColumn = ({ title, dragOver, drop, children, id, autoScroll, rule }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current && autoScroll) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [children]);

  const columnStyle = {
    backgroundColor: "#ffffff",
    height: "15.625rem",
    width: "100%",
    overflow: "hidden",
    padding: "0px 16px",
    borderRadius: "8px",
    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
  };

  const ddZoneStyle = {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflowY: "auto",
    scrollbarWidth: "thin",
    scrollbarColor: "#b0b0b0 #e0e0e0",
  };

  const ddZoneRuleStyle = {
    display: "flex",
    flexWrap: "wrap",
    flex: 1,
    overflowY: "auto",
    scrollbarWidth: "thin",
    scrollbarColor: "#b0b0b0 #e0e0e0",
  };

  const titleStyle = {
    marginBottom: "10px",
    color: "#00b189",
    fontWeight: "bold",
    fontSize: "16px",
  };

  return (
    <div style={columnStyle} onDragOver={dragOver} onDrop={drop}>
      <h6 style={titleStyle}>{title}</h6>
      <div id={id} style={rule ? ddZoneRuleStyle : ddZoneStyle} ref={scrollRef}>
        {children}
      </div>
    </div>
  );
};

export default DDColumn;
